"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactToastNotifications = require("react-toast-notifications");
var _Notification = require("./Notification");
var _NotificationContainer = require("./NotificationContainer");
var NotificationProvider = exports.NotificationProvider = function NotificationProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactToastNotifications.ToastProvider, {
    components: {
      Toast: _Notification.Notification,
      ToastContainer: _NotificationContainer.NotificationContainer
    }
  }, children);
};
NotificationProvider.propTypes = {
  children: _propTypes["default"].any
};